import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import {
  BannerTypes,
  MessageBannerConfig,
} from '@zipari/shared-ds-util-messages';
import { DSAuthService } from '../../auth.service';

@Component({
  selector: 'registration',
  templateUrl: './registration.component.html',
  styleUrls: ['../shared/auth-form.scss', './registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
  @Output() submitRegistrationFormInit: EventEmitter<any> = new EventEmitter();

  config;

  form: UntypedFormGroup;
  isRegistrationComplete: boolean;
  emailVerification: MessageBannerConfig;

  constructor(
    private router: Router,
    public authService: DSAuthService,
  ) {}

  ngOnInit() {
    this.config = this.authService.configuration.registration;

    this.form = new UntypedFormGroup({});
  }

  handleLinkClick(event) {
    if (event.config.prop === 'username') {
      this.router.navigate([this.authService.authUrls.forgotUsername]);
    }

    if (event.config.prop === 'password') {
      this.router.navigate([this.authService.authUrls.forgotPassword]);
    }
  }

  submitRegistrationForm() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.get(key).markAsTouched();
      });
    } else {
      this.submitRegistrationFormInit.emit(this.form.value);
    }
  }

  resendEmail() {
    const hoursInADay = 12;
    const today = new Date();
    const date = `${
      today.getMonth() + 1
    }/${today.getDay()}/${today.getFullYear()}`;
    const time = `${
      today.getHours() < hoursInADay
        ? today.getHours()
        : today.getHours() - hoursInADay
    }:${today.getMinutes()}${today.getHours() < hoursInADay ? 'AM' : 'PM'}`;

    this.emailVerification = {
      type: BannerTypes.success,
      icon: 'check_circle_active',
      message: `Verification resent on ${date} at ${time}`,
    };
  }
}
